import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_URL_HERMES,
});

const activeService =
  process.env.REACT_APP_HERMES_EVENT_ACTIVE === 'true' || false;

const clientUuid = '999-222';

const accessKey = '9eqweq78eq84d1a5fs4aff74asf511as';

class EventService {
  requestUuid;
  terminal;
  zoneUuid;
  context;

  initContext = ({
    requestUuid,
    terminal,
    zoneUuid,
    source = 'Artemis - LP',
  }) => {
    this.requestUuid = requestUuid;
    this.terminal = terminal;
    this.zoneUuid = zoneUuid;

    this.context = {
      source,
      browser: navigator.userAgent,
      sdk: window.SDK_ARTEMIS_KEY,
      sdkVersion: window.SDK_ARTEMIS_VERSION,
    };
  };

  sendEvent = async (campaignUuid, eventName) => {
    // if (activeService) {
    //   const { requestUuid, context, zoneUuid, terminal } = this;
    //   await api.post(`event/publish`, {
    //     requestUuid,
    //     clientUuid,
    //     accessKey,
    //     eventDate: `${new Date().getTime()}`,
    //     context,
    //     properties: {
    //       campaignUuid,
    //       eventName,
    //       terminal,
    //       zoneUuid,
    //     },
    //   });
    // }
  };
}

export default EventService;
